import { Address } from '@/models/address';
import {
    BackendType,
    FrontendType,
    MultiLangString,
    ObjectType,
    StarjackDate,
} from '@/models/general';
import { Money } from './money';
import { convertOrderTicketToFrontend, OrderTicket } from '@/models/ticket';
import { convertKeycardToFrontend, Keycard } from '@/models/keycard';
import { convertDateFromDateArray } from '@/utils/time';

export type Order<T extends ObjectType = FrontendType> = {
    id: string;
    address: Address;
    creationDate: StarjackDate<T>;
    paymentDate: StarjackDate<T>;
    displayId: string;
    free: boolean;
    integrationRef: string;
    invoiceAddress: Address | null;
    payAmount: Money;
    shopProducts: ShopProduct[];
    sixTerminalId: string | null;
    status: OrderStatus;
    tickets: OrderTicket<T>[];
    keycards: Keycard<T>[];
    total: Money;
    vouchers: Voucher<T>[];
};

export const convertOrderToFrontend = (order: Order<BackendType>): Order => ({
    ...order,
    creationDate: convertDateFromDateArray(order.creationDate),
    paymentDate: convertDateFromDateArray(order.paymentDate),
    tickets: order.tickets?.map(convertOrderTicketToFrontend) || [],
    keycards: order.keycards?.map(convertKeycardToFrontend) || [],
    vouchers: order.vouchers?.map(convertVoucherToFrontend) || [],
});

export const convertVoucherToFrontend = (
    responseObject: Voucher<BackendType>
): Voucher => ({
    ...responseObject,
    redemptionDate: convertDateFromDateArray(responseObject.redemptionDate),
});

export enum OrderStatus {
    NEW = 'NEW',
    PAID = 'PAID',
    PAYMENT_STARTED = 'PAYMENT_STARTED',
    PAYMENT_ERROR = 'PAYMENT_ERROR',
}

export type ShopProduct = {
    id: string;
    name: MultiLangString;
    description: MultiLangString;
    price: Money;
    priceReason: string;
    voucher: boolean;
    images: {
        original: string;
        thumbnail: string;
        detail: string;
    };
};

export type Voucher<T extends ObjectType = FrontendType> = {
    id: string;
    price: Money;
    title: string;
    text: string;
    status: string;
    redemptionDate: StarjackDate<T>;
};
